import { EQUAL_WEIGHTS_TITLE } from '@upright/common/model/data';
import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { AggregateMetricProps } from '@upright/ui/common/upright/model/output/scores/aggregate-metrics';
import { NetScoreBlockCustom } from './net-score-block/net-score-block-custom';
import { NetScoreBlockEqualWeights } from './net-score-block/net-score-block-equal-weights';

export function NetScores(props: { scoreUnit: FinalImpactScoreType | undefined } & AggregateMetricProps) {
  const context = useNetImpactLensContext();

  if (!context) {
    return <></>;
  }
  const valueSet = context.options.valueSet;
  const showCustomValueSet = valueSet !== EQUAL_WEIGHTS_TITLE;

  return (
    <>
      <NetScoreBlockEqualWeights
        currentMetric={props.currentMetric}
        setAggregateMetric={props.setAggregateMetric}
        availableMetrics={props.availableMetrics}
      />
      {showCustomValueSet && (
        <NetScoreBlockCustom
          currentMetric={props.currentMetric}
          setAggregateMetric={props.setAggregateMetric}
          availableMetrics={props.availableMetrics}
        />
      )}
    </>
  );
}
